export enum DeliverableReportModes {
  Statement = 'Statement',
  Valuation = 'Valuation',
  JournalEntries = 'JournalEntries',
  Regression = 'Regression',
  JournalEntryAtMaturity = 'JournalEntryAtMaturity',
  Amortisation = 'Amortisation',
}
